import { render, staticRenderFns } from "./CustomersTableForSpecialPrices.vue?vue&type=template&id=1302ba49&scoped=true&"
import script from "./CustomersTableForSpecialPrices.vue?vue&type=script&lang=js&"
export * from "./CustomersTableForSpecialPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1302ba49",
  null
  
)

export default component.exports